import React, { useCallback } from 'react';
import classNames from 'classnames';
import { throttle } from 'lodash';
import { useMediaQuery } from '@common/hooks';

import {
  authTrigger, isUserLoggedIn, setAuthPathAttribute,
} from '@alumni_v2/utils/helpers';

import styles from './TopBannerRevamp.module.scss';
import placementIcon from '@alumni_v2/images/webp/file-report.webp';
import { GTMTracking } from '@common/ui/general';
import { downloadReport } from '@alumni_v2/api/placementReport';
import { PLACEMENT_BANNER_LINK } from '@alumni_v2/utils/constants';
import { Icon } from '@vectord/ui';
import placementMobileIcon from
  '@alumni_v2/images/webp/placement-report-mobile.webp';

const PlacementBannerRevamp = () => {
  const { mobile } = useMediaQuery();

  const sendDataOnDownloadReport = useCallback(async () => {
    await downloadReport({ source: 'alumni_page' });
  }, []);

  const throttledDownloadReport = throttle(() => {
    sendDataOnDownloadReport();
  }, 5 * 60000, { leading: true });

  const openPlacemnetBrochure = useCallback(() => {
    if (isUserLoggedIn()) {
      throttledDownloadReport();
      window.open(PLACEMENT_BANNER_LINK, '_blank');
    } else {
      setAuthPathAttribute(PLACEMENT_BANNER_LINK);
      authTrigger();
    }
  }, [throttledDownloadReport]);


  return (
    <>
      {mobile && (
        <div
          className={classNames(styles.placementContentBannerMobile)}
        >
          <GTMTracking
            component="div"
            gtmEventType="cta"
            gtmEventAction="click"
            gtmEventResult="download_audit_report"
            gtmEventCategory="alumni_directory"
            gtmEventData={{ is_logged_in: isUserLoggedIn() }}
            onClick={openPlacemnetBrochure}
            role="button"
            tabIndex={0}
          >
            <div className={styles.bannerImage}>
              <img
                src={placementMobileIcon}
                alt="placement banner"
              />
              <div className={styles.viewReportBtn}>
                <span className={styles.reportBtn}>View Report Now</span>
                <span className={styles.caretIcon}>
                  <Icon name="caret-right" size="s" />
                </span>
              </div>
            </div>
          </GTMTracking>
        </div>
      )}
      {!mobile && (
        <div
          className={classNames(styles.placementContentBanner)}
        >
          <img
            src={placementIcon}
            alt="placement banner"
          />
          <div className={styles.placementContent}>
            <div className={styles.newTag}>
              <span className={styles.newTagText}>NEW 2024</span>
            </div>
            <div className={styles.heading}>
              2024 Scaler Placement Assessment Report
            </div>
            <GTMTracking
              component="button"
              gtmEventType="cta"
              gtmEventAction="click"
              gtmEventResult="download_audit_report"
              gtmEventCategory="alumni_directory"
              className={styles.placementRightContainer}
              gtmEventData={{ is_logged_in: isUserLoggedIn() }}
              onClick={openPlacemnetBrochure}
              role="button"
              tabIndex={0}
            >
              <span className={styles.reportBtn}>View Report Now</span>
              <span className={styles.caretIcon}>
                <Icon name="caret-right" size="s" />
              </span>
            </GTMTracking>
          </div>
        </div>
      )}
    </>
  );
};

export default PlacementBannerRevamp;
